if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection && this.productSection.querySelector('.product-info');
      this.productForm = this.productSection && this.productSection.querySelector('product-form');
      this.visibilityObserver = null;
      this.onScroll = () => {
        this.updateVisibility();
        StickyAtcPanel.handleScroll();
      };

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
    }

    // KIBI CRO sticky visibility fallback: keep the buy prompt available after the form leaves view.
    updateVisibility() {
      if (!this.productForm || !this.productInfo) return;

      if (!theme.mediaMatches.md) {
        const formRect = this.productForm.getBoundingClientRect();
        this.classList.toggle('sticky-atc-panel--out', formRect.bottom > 0);
      } else {
        const infoRect = this.productInfo.getBoundingClientRect();
        const infoIsVisible = infoRect.bottom > 0 && infoRect.top < window.innerHeight;
        this.classList.toggle('sticky-atc-panel--out', infoIsVisible);
      }
    }

    bindEvents() {
      this.visibilityObserver = new IntersectionObserver(() => this.updateVisibility());

      if (this.productForm) this.visibilityObserver.observe(this.productForm);
      if (this.productInfo) this.visibilityObserver.observe(this.productInfo);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      requestAnimationFrame(() => this.updateVisibility());
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
